// extracted by mini-css-extract-plugin
export var imageSlice = "styles-module--imageSlice---fSAu";
export var backAndForthRight = "styles-module--backAndForthRight--A5c93";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--qGRve";
export var animateBg = "styles-module--animateBg--VbCs8";